<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <div class="pd-10 bg-white">
      <!-- 返回按钮 -->
      <div
        class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor mgb-15"
        @click="goreturn"
      >
        <i class="el-icon-arrow-left fw-600"></i>
        返回
      </div>
      <!--  -->
      <el-descriptions border>
        <el-descriptions-item label="员工姓名">{{
          dataInfo.name
        }}</el-descriptions-item>
        <el-descriptions-item label="员工电话">{{
          dataInfo.phone
        }}</el-descriptions-item>
        <el-descriptions-item label="员工角色">{{
          dataInfo.userRoleName
        }}</el-descriptions-item>
      </el-descriptions>

      <!-- 选项 -->
      <div class="selectBox">
        <div
          :class="selectActive == v.id ? 'selectActive' : 'select'"
          v-for="(v, i) in selectArr"
          :key="i"
          @click="selectChange(v)"
        >
          {{ v.name }}
        </div>
      </div>
      <!-- 员工管理分区 -->
      <div v-show="selectActive == 1" class="mgt-20">
        <div class="mgb-20" v-if="Number(form.dataQuan) !== 2">
          <el-button @click="handleZhuan">转移</el-button>
          <el-button @click="handleAdd">新增</el-button>
        </div>
        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            type="index"
            :index="indexMethod"
            label="序号"
            width="50"
            fixed="left"
          >
          </el-table-column>
          <el-table-column prop="regionName" label="分区名称">
          </el-table-column>
          <el-table-column prop="createTime" label="添加时间">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="80">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                :disabled="Number(form.dataQuan) == 2"
                @click="handleUnbind(scope.row)"
                >解绑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 员工权限 -->
      <div v-show="selectActive == 2" class="mgt-20">
        <!-- 操作面板 -->
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="功能权限">
            <div class=" bg-white quan">
              <el-checkbox-group disabled v-model="form.funQuan">
                <el-checkbox
                  v-for="(v, i) in menuType"
                  :key="i"
                  :label="v.dictName"
                  :name="v.dictName"
                ></el-checkbox>
              </el-checkbox-group>
              <!-- 工作台数据 -->
              <div class="dataBox" v-if="form.funQuan.indexOf('首页') !== -1">
                <div v-for="(v, i) in homeArr" :key="i">
                  <div>{{ v.name }}</div>
                  <el-checkbox-group disabled v-model="form.jobLook">
                    <el-checkbox
                      v-for="(v2, i2) in v.children"
                      :key="i2"
                      :label="v2.id"
                      >{{ v2.name }}</el-checkbox
                    >
                  </el-checkbox-group>
                </div>
              </div>
              <!-- 数据看板 -->
              <div class="dataBox" v-if="form.funQuan.indexOf('数据') !== -1">
                <div v-for="(v, i) in dataArr" :key="i">
                  <div>{{ v.name }}</div>
                  <el-checkbox-group disabled v-model="form.dataLook">
                    <el-checkbox
                      v-for="(v2, i2) in v.children"
                      :key="v2.id"
                      :label="v2.id"
                    >
                      {{ v2.name }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="数据权限">
            <div class=" bg-white quan">
              <el-radio-group disabled v-model="form.dataQuan">
                <el-radio label="2">{{ "全部数据" }}</el-radio>
                <!-- <el-radio label="1">{{ "区域数据" }}</el-radio> -->
                <el-radio label="0">{{ "个人数据" }}</el-radio>
              </el-radio-group>
              <div>数据说明:</div>
              <div>
                1、全部数据为归属企业全部设备、员工、水卡、用户等产生的数据；
              </div>
              <!-- <div>
                2、区域数据为管理区域下全部设备、员工、水卡等产生的数据；
              </div> -->
              <div>2、个人数据为管理设备、水卡等产生的数据。</div>
            </div>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary">保存</el-button>
          </el-form-item> -->
        </el-form>
      </div>

      <!-- 客户信息 -->
      <div v-show="selectActive == 3" class="mgt-20">
        <div class="flex aic jcsb mgb-10">
          <el-button v-if="clentTable.length > 0" @click="clientZhuanBtn"
            >用户关系转移</el-button
          >
          <div class="flex aic">
            <el-input
              v-model="clientPhone"
              placeholder="请输入用户手机号"
            ></el-input>
            <el-button class="mgl-15" @click="getClient()">查询</el-button>
            <el-button
              @click="
                clientPhone = '';
                getClient();
              "
              >重置</el-button
            >
          </div>
        </div>
        <div class="mgb-15">客户总数：{{ total }}</div>
        <el-table :data="clentTable" border stripe style="width: 100%">
          <el-table-column
            type="index"
            :index="indexMethod2"
            label="序号"
            width="50"
            fixed="left"
          >
          </el-table-column>
          <el-table-column prop="customerName" label="昵称"> </el-table-column>
          <el-table-column prop="customerPhone" label="电话"> </el-table-column>

          <el-table-column prop="regionName" label="所属区域">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="handleClientDetail(scope.row)"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <el-pagination
          class="mgt-20"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[5, 20, 30, 40, 50]"
          :page-size="pageSize"
          layout=" prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>

      <!-- 充值统计 -->
      <div v-show="selectActive == 4" class="mgt-20">
        <!-- 按钮 -->
        <div class="flex aic jcsb mgb-15">
          <el-button @click="exportBtn">导出</el-button>
          <div>
            <el-button
              v-for="(v, i) in topStatArr"
              :key="i"
              :type="topStatActive == v.id ? 'primary' : ''"
              @click="
                topStatActive = v.id;
                getTopStat();
              "
              >{{ v.name }}</el-button
            >
          </div>
        </div>
        <!-- 表格 -->
        <el-table :data="topTable" border stripe style="width: 100%">
          <el-table-column
            type="index"
            :index="indexMethodTop"
            label="序号"
            width="50"
            fixed="left"
          >
          </el-table-column>
          <el-table-column prop="day" label="时间">
            <template slot-scope="scope">
              <span
                v-text="topStatActive == 1 ? scope.row.day : scope.row.month"
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="orderNum" label="充值订单数">
          </el-table-column>
          <el-table-column prop="orderMoney" label="充值总金额">
          </el-table-column>
          <el-table-column prop="giveMoney" label="充值赠送金额">
          </el-table-column>
          <el-table-column prop="payMoney" label="充值实付金额">
          </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <el-pagination
          class="mgt-20"
          background
          @size-change="handleSizeChangeTop"
          @current-change="handleCurrentChangeTop"
          :current-page="pageTop"
          :page-sizes="[5, 20, 30, 40, 50]"
          :page-size="pageSizeTop"
          layout=" prev, pager, next"
          :total="totalTop"
        >
        </el-pagination>
      </div>

      <!-- 用户关系转移弹框 -->
      <el-dialog
        title="用户关系转移"
        :visible.sync="clientZhuanVisible"
        width="30%"
        top="30vh"
        center
        :close-on-click-modal="false"
      >
        <el-form
          :rules="clientZhuanFormRules"
          ref="clientZhuanForm"
          :model="clientZhuanForm"
          label-width="80px"
        >
          <el-form-item label="转移方式">
            <el-radio-group v-model="clientZhuanForm.way">
              <el-radio label="全部用户"></el-radio>
              <el-radio label="区域用户"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="所属区域"
            prop="region"
            v-if="clientZhuanForm.way == '区域用户'"
          >
            <el-select
              v-model="clientZhuanForm.region"
              placeholder="请选择所属区域"
            >
              <el-option
                v-for="(v, i) in fenquArr"
                :key="i"
                :label="v.regionName"
                :value="v.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="接收员工" prop="staff">
            <el-select
              v-model="clientZhuanForm.staff"
              placeholder="请选择接收员工"
            >
              <el-option
                v-for="(v, i) in userArr"
                :key="i"
                :label="v.name"
                :value="v.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <div style="color: red;">
            温馨提示：若接收用户关系的员工区域权限不足，则该员工无法查看该区域内的用户情况。
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button class="mgr-30" @click="clientZhuanVisible = false"
            >取 消</el-button
          >
          <el-button
            type="primary"
            @click="handleClientZhuan('clientZhuanForm')"
            >确 定</el-button
          >
        </span>
      </el-dialog>

      <!-- 客户详情弹框 -->
      <el-dialog
        title="客户详情"
        :visible.sync="clientVisible"
        width="45%"
        top="30vh"
        center
        :close-on-click-modal="false"
      >
        <el-table :data="clientDetailTable" border stripe style="width: 100%">
          <el-table-column
            type="index"
            :index="indexMethod3"
            label="序号"
            width="50"
            fixed="left"
          >
          </el-table-column>
          <el-table-column prop="cardType" label="水卡类型">
            <template slot-scope="scope">
              <span
                v-text="
                  scope.row.cardType == 1
                    ? '电子卡'
                    : scope.row.cardType == 2
                    ? '实物卡'
                    : scope.row.cardType == 3
                    ? '时效电子卡'
                    : scope.row.cardType == 4
                    ? '时效实物卡'
                    : '- -'
                "
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="水卡状态">
            <template slot-scope="scope">
              <span
                v-text="
                  scope.row.cardStatus == 0
                    ? '正常'
                    : scope.row.cardStatus == 1
                    ? '已挂失'
                    : scope.row.cardStatus == 2
                    ? '异常'
                    : '已失效'
                "
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="cardId" label="水卡编号"> </el-table-column>
          <el-table-column prop="currentBalance" label="水卡余额(元)">
          </el-table-column>
          <el-table-column prop="regionName" label="所属区域">
          </el-table-column>

          <el-table-column prop="createTime" label="创建时间">
          </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <el-pagination
          class="mgt-20"
          background
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="page2"
          :page-sizes="[5, 20, 30, 40, 50]"
          :page-size="pageSize2"
          layout=" prev, pager, next"
          :total="total2"
        >
        </el-pagination>
        <span slot="footer" class="dialog-footer">
          <el-button @click="clientVisible = false">已知晓</el-button>
        </span>
      </el-dialog>

      <!-- 弹框 -->
      <el-dialog
        :title="tanType === 1 ? '转移分组' : '新增分组'"
        :visible.sync="dialogVisible"
        width="30%"
        center
        :close-on-click-modal="false"
        top="30vh"
      >
        <el-form
          ref="tanForm"
          :rules="tanFormRules"
          :model="tanForm"
          label-width="80px"
        >
          <el-form-item label="管理员工" prop="staff" v-if="tanType == 1">
            <el-select
              filterable
              v-model="tanForm.staff"
              placeholder="请选择分区管理员工"
            >
              <el-option
                v-for="(v, i) in userArr"
                :key="i"
                :label="v.name"
                :value="v.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目组" prop="group" v-if="tanType == 2">
            <el-select
              filterable
              v-model="tanForm.group"
              placeholder="请选择需要管理的分区"
            >
              <el-option
                v-for="(v, i) in zoneArr"
                :key="i"
                :label="v.regionName"
                :value="v.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button class="mgr-30" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button type="primary" @click="saveData('tanForm')">{{
            tanType === 1 ? "转 移" : "新 增"
          }}</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 导出弹框 -->
    <el-dialog
      title="导出"
      :visible.sync="exportVisible"
      width="30%"
      center
      top="30vh"
    >
      <el-form ref="exportForm" :model="exportForm" label-width="80px">
        <el-form-item label="统计类型">
          <el-select v-model="exportForm.type" placeholder="请选择">
            <el-option label="日统计" value="1"></el-option>
            <el-option label="月统计" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易时间">
          <div class="flex">
            <el-date-picker
              v-model="exportForm.startTime"
              format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="开始日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="exportForm.endTime"
              :picker-options="pickerOptionsEnd8"
              format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="exportVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="exportSureBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      selectArr: [
        { id: 1, name: "员工管理分区" },
        { id: 2, name: "员工权限" },
        { id: 3, name: "客户信息" },
        { id: 4, name: "充值统计" },
      ],
      selectActive: 1,
      tableData: [],
      dialogVisible: false,
      tanType: null,
      tanForm: {
        staff: "",
        group: "",
      },
      dataArr: [], //数据看板菜单数组
      homeArr: [], //首页的功能模块菜单
      allArr: [],
      tanFormRules: {
        staff: [
          { required: true, message: "请选择分区管理员工", trigger: "blur" },
        ],
        group: [
          { required: true, message: "请选择需要管理的分区", trigger: "blur" },
        ],
      },
      form: {
        funQuan: [],
        dataLook: [], //数据看板数据
        jobLook: [], //工作台数据，后台返回
        dataQuan: [],
      },
      dataInfo: null,
      userArr: [],
      multipleSelection: [],
      zoneArr: [],
      menuType: [],
      clentTable: [], //客户信息表格
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      // 分页数据
      page2: 1, // 当前页，默认
      pageSize2: 10, //每页显示多少条数据，默认
      total2: 50, // 数据总条数
      clientVisible: false, //客户详情弹框
      clientDetailTable: [], //客户详情表格数据
      clientZhuanVisible: false, //用户关系转移弹框
      clientZhuanForm: {
        way: "全部用户",
        staff: "",
        region: "",
      },
      clientZhuanFormRules: {
        region: [
          { required: true, message: "请选择所属区域", trigger: "blur" },
        ],
        staff: [{ required: true, message: "请选择接收员工", trigger: "blur" }],
      },
      clientId: null,
      clientPhone: "",
      fenquArr: [],
      salesName: null,
      companyId: null,
      regionId: null,
      topStatArr: [
        { name: "日统计", id: 1 },
        { name: "月统计", id: 2 },
      ],
      topStatActive: 1,
      topTable: [],
      // 分页数据
      pageTop: 1, // 当前页，默认
      pageSizeTop: 10, //每页显示多少条数据，默认
      totalTop: 50, // 数据总条数
      fuwuduan: [],
      exportForm: { type: "", startTime: "", endTime: "" },
      exportVisible: false,
      pickerOptionsEnd8: {
        disabledDate: (time) => {
          let beginDateVal = this.exportForm.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
    };
  },
  created() {
    this.dataInfo = this.$route.query.data;

    this.getList();
    this.getMenu();
    this.getMenuType();
    this.getDetail();
    this.getClient();
    if (this.$route.query.id) {
      this.selectActive = 4;
    }
    this.getTopStat(); //充值统计数据
  },
  methods: {
    handleSizeChangeTop(val) {
      this.pageSizeTop = val;
      this.getTopStat(this.pageTop);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChangeTop(val) {
      this.pageTop = val;
      this.getTopStat();
    },
    exportBtn() {
      this.exportForm.type = "";
      this.exportForm.startTime = "";
      this.exportForm.endTime = "";
      this.exportVisible = true;
    },
    exportSureBtn() {
      if (this.exportForm.type == "") {
        handleAlert("请选择统计类型", "error");
        return;
      }
      handleConfirm("确认导出吗?", "info")
        .then(() => {
          this.$api.sellTeam
            .staffTopStatExport({
              type: this.exportForm.type ? this.exportForm.type : null,
              startTime: this.exportForm.startTime
                ? this.exportForm.startTime
                : null,
              endTime: this.exportForm.endTime ? this.exportForm.endTime : null,
              staffId: this.dataInfo.id,
            })
            .then((res) => {
              handleAlert("导出成功", "success");
              this.exportVisible = false;
              const link = document.createElement("a");
              link.style.display = "none";
              link.href = URL.createObjectURL(res);
              link.setAttribute("download", "充值统计.xls");
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            });
        })
        .catch(() => {
          return;
        });
    },
    getTopStat() {
      this.$api.sellTeam
        .staffTopStat({
          staffId: this.dataInfo.id,
          type: this.topStatActive,
        })
        .then((res) => {
          if (res.code === 200) {
            this.topTable = res.data.rows;
            this.totalTop = res.data.total;
          }
        });
    },
    goreturn() {
      if (this.$route.query.id) {
        this.$router.push({
          path: "/staff/sellTeam/teamDetail",
          query: {
            id: this.$route.query.id,
          },
        });
      } else {
        this.$router.push("/staff/staff");
      }
    },
    handleClientZhuan(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm("确认转移用户关系吗?", "info")
            .then(() => {
              this.userArr.forEach((v) => {
                if (this.clientZhuanForm.staff == v.id) {
                  this.salesName = v.name;
                }
              });
              this.$api.staffClient
                .clientZhuan({
                  type: this.clientZhuanForm.way == "全部用户" ? 0 : 1,
                  salesId: this.clientZhuanForm.staff,
                  salesName: this.salesName,
                  regionId:
                    this.clientZhuanForm.way == "全部用户"
                      ? null
                      : this.clientZhuanForm.region,
                  nowSalesId: this.dataInfo.id,
                })
                .then((res) => {
                  if (res.code == 200) {
                    handleAlert("转移成功", "success");
                    this.getClient();
                    this.clientZhuanVisible = false;
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },
    clientZhuanBtn() {
      this.clientZhuanForm = {
        way: "全部用户",
        staff: "",
        region: "",
      };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.clientZhuanForm.clearValidate();
      });
      this.getFenqu();
      this.getUser();

      this.clientZhuanVisible = true;
    },

    // 分区下拉
    getFenqu() {
      // this.$api.marketing.allZonePull().then((res) => {
      //   if (res.code === 200) {
      //     this.fenquArr = res.data;
      //   }
      // });
      this.fenquArr = [];
      this.clentTable.forEach((v) => {
        if (!this.fenquArr.find((item) => item.id === v.regionId)) {
          // 如果没有相同的 regionId，则添加到 fenquArr
          this.fenquArr.push({ regionName: v.regionName, id: v.regionId });
        }
      });
    },
    handleClientDetail(row) {
      this.clientId = row.customerPhone;
      this.companyId = row.companyId;
      this.regionId = row.regionId;

      this.getClientDetail();
    },
    getClientDetail(pageNum) {
      if (!pageNum) {
        this.page2 = 1;
      }
      this.$api.staffClient
        .staffClientCardList({
          pageNum: this.page2,
          pageSize: this.pageSize2,
          customerPhone: this.clientId,
          companyId: this.companyId,
          regionId: this.regionId,
        })
        .then((res) => {
          if (res.code === 200) {
            this.clientDetailTable = res.data.list;
            this.total2 = res.data.total;
            this.clientVisible = true;
          }
        });
    },
    // 客户信息表格
    getClient(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.staffClient
        .staffClientListNew2({
          pageNum: this.page,
          pageSize: this.pageSize,
          salesId: this.dataInfo.id,
          customerPhone: this.clientPhone,
        })
        .then((res) => {
          if (res.code === 200) {
            this.clentTable = res.data.list;
            this.total = res.data.total;
          }
        });
    },
    // ======字典表所属菜单
    getMenuType() {
      this.$api.dict.list({ dictName: "H5菜单权限所属模块" }).then((res) => {
        if (res.code === 200) {
          this.menuType = [];
          res.data.forEach((v) => {
            if (v.dictPid !== 0) {
              this.menuType.push(v);
            }
          });
        }
      });
    },

    getList() {
      this.$api.staff.fenList({ userId: this.dataInfo.id }).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data;
        }
      });
    },
    // 分区解绑
    handleUnbind(row) {
      handleConfirm("确认解绑该分区吗?", "info")
        .then(() => {
          this.$api.staff.fenUnBind({ id: row.id }).then((res) => {
            if (res.code === 200) {
              handleAlert("解绑成功", "success");
              this.getList();
            }
          });
        })
        .catch(() => {
          return;
        });
    },
    // 员工下拉接口
    getUser() {
      this.$api.staff
        .userPullNewClassTwo({ roleId: this.dataInfo.userRoleId })
        .then((res) => {
          if (res.code === 200) {
            this.userArr = res.data;
          }
        });
    },
    getMenu() {
      this.$api.system.userMenuList({ serverId: 1 }).then((res) => {
        if (res.code === 200) {
          var data = res.data.filter((e) => e.pid == 0);
          this.dataArr = [];
          this.homeArr = [];

          var temp = [];
          data.forEach((e) => {
            e.children = res.data.filter((c) => c.pid == e.id);
            temp.push(e);
          });
          this.allArr = temp;
          temp.forEach((v) => {
            if (v.name === "数据") {
              this.dataArr.push(v);
            } else {
              this.homeArr.push(v);
            }
          });
        }
      });
    },
    // 保存按钮
    saveData(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          if (this.tanType === 2) {
            handleConfirm("确认新增项目组吗?", "info")
              .then(() => {
                this.$api.staff
                  .fenAdd({ id: this.tanForm.group, userId: this.dataInfo.id })
                  .then((res) => {
                    if (res.code === 200) {
                      handleAlert("新增成功", "success");
                      this.getList();
                      this.dialogVisible = false;
                    }
                  });
              })
              .catch(() => {
                return;
              });
          } else {
            handleConfirm("确认转移项目组吗?", "info")
              .then(() => {
                this.$api.staff
                  .fenQian({
                    id: this.multipleSelection[0].id,
                    userId: this.tanForm.staff,
                  })
                  .then((res) => {
                    if (res.code === 200) {
                      handleAlert("转移成功", "success");
                      this.getList();
                      this.dialogVisible = false;
                    }
                  });
              })
              .catch(() => {
                return;
              });
          }
        } else {
          return false;
        }
      });
    },
    // 详情
    getDetail() {
      this.$api.staff
        .staffRoleDetail({ id: this.dataInfo.userRoleId, serverId: 1 })
        .then((res) => {
          console.log(res, "详情-员工");
          if (res.code === 200) {
            // this.form.name = res.data.name;
            // this.form.status = res.data.status.toString();
            this.form.dataQuan = res.data.dataStatus.toString();

            res.data.futureCompanyMenuBeans.forEach((v) => {
              this.menuType.forEach((v2) => {
                if (v.type === v2.dictId) {
                  v.type = v2.dictName;
                } else {
                  v.type = v.type;
                }
              });
              if (v.type === "数据") {
                this.form.funQuan.push("数据");
              } else if (v.type === "首页") {
                this.form.funQuan.push("首页");
              }
              v.childrens.forEach((v2) => {
                if (v.type === "数据") {
                  this.form.dataLook.push(Number(v2.id));
                } else if (v.type === "首页") {
                  this.form.jobLook.push(Number(v2.id));
                }
              });
            });
          }
        });
    },
    handleZhuan() {
      if (this.multipleSelection.length !== 1) {
        handleAlert("请选择一条数据", "error");
        return;
      }
      this.getUser();
      this.tanType = 1;
      this.dialogVisible = true;
      this.tanForm = {
        staff: "",
        group: "",
      };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.tanForm.clearValidate();
      });
    },
    // 区域下拉
    getZonePull() {
      this.$api.zone.zonePull().then((res) => {
        if (res.code === 200) {
          this.zoneArr = res.data;
        }
      });
    },
    handleAdd() {
      this.getZonePull();
      this.tanType = 2;
      this.dialogVisible = true;
      this.tanForm = {
        staff: "",
        group: "",
      };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.tanForm.clearValidate();
      });
    },
    selectChange(v) {
      this.selectActive = v.id;
      if (v.id === 2) {
        this.getDetail();
      }
      if (v.id === 3) {
        this.getClient();
      }
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    indexMethod2(index) {
      return index + 1;
    },
    indexMethod3(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getClient(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getClient(this.page);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.getClientDetail(this.page2);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange2(val) {
      this.page2 = val;
      this.getClientDetail(this.page2);
    },
  },
};
</script>

<style lang="scss" scoped>
.selectBox {
  display: flex;
  align-items: center;
  margin-top: 20px;
  .select {
    margin-right: 50px;
    cursor: pointer;
    text-decoration: underline;
  }
  .selectActive {
    margin-right: 50px;
    cursor: pointer;
    text-decoration: underline;
    color: #197ff9;
  }
}

.dataBox {
  border: 1px solid var(--input-border);
  padding: 10px;
  margin-top: 15px;
}
</style>
